import { gql } from "@apollo/client";

export const GET_HEADQUARTERS = gql`
  query GetHeadquartersResolver {
    getHeadquartersResolver {
      _id
      name
      code
      status
    }
  }
`;
